// Copyright (c) StrangeBee 2024

import { supportedAttachmentTypes } from '@Molecules/THPreview';

export const commentAttachmentContentTypes: Record<string, string[]> = {
    doc: [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroEnabled.12',
        'application/vnd.ms-word.template.macroEnabled.12',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.google-apps.document',
        'application/vnd.apple.pages',
        'application/vnd.ms-works',
        'application/wordperfect',
        'application/x-abiword',
        'application/x-zoho-doc',
        'application/vnd.softmaker',
        'application/x-kword',
    ],

    archive: [
        'application/zip',
        'application/gzip',
        'application/x-tar',
        'application/vnd.rar',
        'application/x-7z-compressed',
    ],

    imageInvalid: ['image/svg+xml', 'image/x-icon', 'image/vnd.microsoft.icon'],
    imageValid: [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/tiff',
        'image/webp',
        'image/x-icon',
        'image/vnd.microsoft.icon',
    ],

    text: supportedAttachmentTypes.text,

    excel: [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-excel.template.macroEnabled.12',
        'application/vnd.google-apps.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet',
    ],
    pdf: ['application/pdf'],
};
